import { useLocalStore, useAsObservableSource } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import dateService from '@gem/services/date-service';

import Entities from 'STORE';

export const useUserPresenter = ({ userId, closePopup }) => {
  const source = useAsObservableSource({ userId, closePopup });
  const { t } = useTranslation();
  const presenter = useLocalStore(() => ({
    get user() {
      return Entities.usersStore.getUserById(source.userId);
    },

    get avatarTitle() {
      return presenter.user?.avatarTitle || presenter.user?.name;
    },

    get avatarUrl() {
      return presenter.user?.avatarUrl || presenter.user?.avatar || presenter.user?.image;
    },

    get avatarBackgroundColorIndex() {
      return presenter.user?.avatarColorIndex;
    },

    get title() {
      return presenter.user?.displayName || presenter.user?.userName;
    },

    get subtitle() {
      const lastOnlineTs = presenter.user?.lastOnlineTs;
      const isToday = dateService.isToday(lastOnlineTs);
      const dateOptions = isToday
        ? { hour: 'numeric', minute: 'numeric' }
        : {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          };
      const formattedDate = dateService.format(lastOnlineTs, dateOptions);

      if (!formattedDate) {
        return t('last_seen_a_long_time_ago');
      }

      return t('last_seen_at', { 0: formattedDate });
    },

    get isDisabled() {
      return presenter.isLoading;
    },
  }));

  return presenter;
};
